<template>
    <div style="height: 100%">
        <v-card height="100%">
            <GmapMap
                ref="map"
                :center="{
                    lat: location.lat,
                    lng: location.lng,
                }"
                :zoom="10"
                :options="{
                    zoomControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                    styles
                }"
                map-type-id="roadmap"
                class="map"
            >
                <div v-if="currMeters.length === 0 && i === 0">
                    <div :key="meter.name" v-for="meter in meters">
                        <GmapMarker
                            id="meter.name"
                            v-if="meter.location"
                            :position="{ lat: meter.location.latitude, lng: meter.location.longitude, }"
                            :visible="true"
                            :icon="getIcon(meter)"
                        /> 
                    </div>
                </div>
                <div v-else>
                    <div :key="meter.name" v-for="meter in currMeters">
                        <GmapMarker
                            id="meter.name"
                            v-if="meter.location"
                            :position="{ lat: meter.location.latitude, lng: meter.location.longitude, }"
                            :visible="true"
                            :icon="getIcon(meter)"
                        /> 
                    </div>
                </div>
                    
            </GmapMap>
            <div class="redirect">
                <v-btn-toggle>
                    <v-btn small color="white" class="accent--text" @click="displayMap()">Show on Map</v-btn>              
                </v-btn-toggle>
            </div>
            <div class="filterOn">
                <v-btn-toggle>
                    <v-btn small color="white" class="grey--text" @click="retrieveMeters('ALL')">Show All Devices</v-btn>
                    <v-btn small color="white" class="green--text" @click="retrieveMeters('ON')">On Devices</v-btn>
                    <v-btn small color="white" class="black--text" @click="retrieveMeters('OFF')">Off Devices</v-btn>
                    <v-btn small color="white" class="red--text" @click="retrieveMeters('OUT')">Offline Devices</v-btn>                
                </v-btn-toggle>
            </div>
        </v-card>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { default as mapStyle } from '../../plugins/mapStyle.json'
export default {
    name: 'mapMeter',
    props: ['location', 'meters', 'groupName'],
    computed:{
        ...mapState({
            arrayON: state => state.meters.arrayON,
            arrayUP: state => state.meters.arrayUP,
            arrayDOWN: state => state.meters.arrayDOWN,
            arrayOFF: state => state.meters.arrayOFF,
            arrayOUT: state => state.meters.arrayOUT,
        }),
        mapCustom(){
            return mapStyle
        },
        styles(){
            return this.mapCustom
        }
    },
    data(){
        return{
            devsON: [],
            devsOFF: [],
            devsOUT: [],
            currMeters: [],
            i: 0,
        }
    },
    methods: {
        displayMap(){
            this.$router.push({ name: 'GroupMap', params: {location: this.location, zoom: 16, name: this.groupName, meters: this.meters} })
        },
        getIcon(meter){
            let m
            m = this.arrayUP.find(m => m.name === meter.name)
            if (m != undefined) {
                return { url: require('../../assets/map/icon-orange.png'), 
                    scaledSize: {width: 30, height: 30, f: 'px', b: 'px'},
                }        
            }
            m = this.arrayDOWN.find(m => m.name === meter.name)
            if (m != undefined) {
                return { url: require('../../assets/map/icon-yellow.png'), 
                    scaledSize: {width: 30, height: 30, f: 'px', b: 'px'},
                }        
            }
            m = this.arrayON.find(m => m.name === meter.name)
            if (m != undefined) {
                return { url: require('../../assets/map/icon-green.png'), 
                    scaledSize: {width: 30, height: 30, f: 'px', b: 'px'},
                }
            }
            m = this.arrayOFF.find(m => m.name === meter.name)
            if (m != undefined) {
                return { url: require('../../assets/map/icon-dark.png'), 
                    scaledSize: {width: 30, height: 30, f: 'px', b: 'px'},
                }
            }
            m = this.arrayOUT.find(m => m.name === meter.name)
            if (m != undefined) {
                return { url: require('../../assets/map/icon-red.png'), 
                    scaledSize: {width: 30, height: 30, f: 'px', b: 'px'},
                }
            }
        },
        async retrieveMeters(status){
            switch (status) {
                case 'ON':
                    this.i = 1
                    this.currMeters = this.devsON
                    break;
                case 'OFF':
                    this.i = 2
                    this.currMeters = this.devsOFF
                    break;
                case 'OUT':
                    this.i = 3
                    this.currMeters = this.devsOUT
                    break;
                default:
                    this.i = 0
                    this.currMeters = []
                    break;
            }
        },
    },
    created(){
        let e
        for (let index = 0; index < this.meters.length; index++) {
            let element = this.meters[index];
            e = this.arrayON.find(m => m.name === element.name)
            if(e != undefined){
                this.devsON.push(e)
                continue
            }
            e = this.arrayOFF.find(m => m.name === element.name)
            if(e != undefined){
                this.devsOFF.push(e)
                continue
            }
            e = this.arrayOUT.find(m => m.name === element.name)
            if(e != undefined){
                this.devsOUT.push(e)
                continue
            }
        }
    }
}
</script>

<style scoped>
.map{
    height: 340px;
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
}
.redirect{
    position: absolute;
    top: 10px;
    left: 10px
}
.filterOn {
    position: absolute;
    z-index: 1;
    top: 10px;
    right: 8px;
}
</style>